var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-container" },
    [
      _c(
        "el-button",
        {
          style: { background: _vm.color, borderColor: _vm.color },
          attrs: { icon: "el-icon-upload", size: "mini", type: "primary" },
          on: {
            click: function ($event) {
              _vm.dialogVisible = true
            },
          },
        },
        [_vm._v("上传视频")]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "上传视频",
            "append-to-body": true,
            "close-on-press-escape": false,
            "close-on-click-modal": false,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              staticClass: "avatar-uploader",
              attrs: {
                action: _vm.uploadPath,
                headers: _vm.headers,
                "show-file-list": false,
                "on-progress": _vm.progress,
                "before-upload": _vm.beforeAvatarUpload,
                "on-success": _vm.handleAvatarSuccess,
                "on-error": _vm.handleAvatarError,
              },
              scopedSlots: _vm._u([
                {
                  key: "tip",
                  fn: function () {
                    return undefined
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm.file && _vm.checkFileType(_vm.file) == "视频"
                ? _c("video", {
                    staticClass: "avatar",
                    attrs: { src: _vm.file, autoplay: "" },
                  })
                : _c("i", {
                    staticClass: "el-icon-plus avatar-uploader-icon avatar",
                  }),
            ]
          ),
          _vm._v(" "),
          _vm.show
            ? _c(
                "div",
                { staticClass: "progress" },
                [_c("el-progress", { attrs: { percentage: _vm.percentage } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.show },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }